import React from 'react';
import {
  BooleanField,
  Datagrid,
  Filter,
  List,
  NumberField,
  NumberInput,
  Pagination,
  ReferenceManyField,
  Show,
  ShowButton,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
  DateInput,
  DateField,
  TopToolbar,
} from 'react-admin';
import { Link } from 'react-router-dom';
import DownloadActivityFileButton from './download-activity-file-button';

export const ActivityLink = ({ record }: any) =>
  record?.activityId ? <Link to={`/activity/${record.activityId}/show`}>{record.activityId}</Link> : null;

const ActivityFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Title" source="title" />
    <TextInput label="Sport" source="type" alwaysOn />
    <TextInput label="Source" source="source" alwaysOn />
    <TextInput label="Distance <=" source="distance||$lte" alwaysOn />
    <TextInput label="Distance >=" source="distance||$gte" alwaysOn />
    <NumberInput label="User ID" source="userId||$eq" alwaysOn />
    <DateInput label="Date <=" source="startDate||$gt" />
    <DateInput label="Date >=" source="startDate||$lt" />
  </Filter>
);

export const ActivityList = (props: any) => (
  <List {...props} filters={<ActivityFilter />} sort={{ field: 'startDate', order: 'DESC' }}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="user.username" label="Username" />
      <NumberField source="userId" label="User ID" />
      <TextField source="startDate" />
      <TextField source="title" />
      <TextField source="type" />
      <TextField source="source" />
      <NumberField source="distance" />
      <NumberField source="duration" />
      <ShowButton />
    </Datagrid>
  </List>
);

const ActivityShowActions = (props: any) => (
  <TopToolbar>{props.permissions === 'superadmin' && <DownloadActivityFileButton activityId={props.data?.id} />}</TopToolbar>
);

export const ActivityShow = (props: any) => (
  <Show {...props} actions={<ActivityShowActions {...props} />}>
    <TabbedShowLayout>
      <Tab label="General">
        <TextField source="id" />
        <TextField source="title" />
        <DateField source="startDate" />
        <TextField source="utcOffset" />
        <TextField source="type" />
        <NumberField source="distance" />
        <NumberField source="duration" />
        <TextField source="source" />
        <TextField source="boundingBoxNE" />
        <TextField source="boundingBoxSW" />
      </Tab>
      <Tab label="User">
        <TextField source="user.id" label="ID" />
        <TextField source="user.username" label="Username" />
        <TextField source="user.email" label="Email" />
      </Tab>
      <Tab label="Participations">
        <ReferenceManyField
          pagination={<Pagination />}
          perPage={10}
          label="Participation"
          reference="participation"
          target="activityId"
        >
          <Datagrid>
            <NumberField source="id" />
            <TextField source="room.event_title" label="Race" />
            <NumberField source="roomId" label="Race ID" />
            <TextField source="user.username" />
            <TextField source="time" label="Time [s]" />
            <TextField source="distance" label="Distance [m]" />
            <DateField source="createdAt" />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="Matches">
        <ReferenceManyField
          pagination={<Pagination />}
          perPage={10}
          label="ActivityRoomMatch"
          reference="activity-room-match"
          target="activityId"
        >
          <Datagrid>
            <NumberField source="id" />
            <NumberField source="roomId" />
            <BooleanField source="used" />
            <BooleanField source="triedToParticipate" />
            <TextField source="participateError" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);
